import React from 'react';
import { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { useHistory } from 'react-router-dom';
import Container from 'common/Container';
import NotFoundIllustration from 'svg/illustrations/NotFound';

const CONTACT_PHONE_DISPLAY = '+1 (614) 579-0661';
const CONTACT_PHONE_LINK = 'tel:+16145790661';
const CONTACT_SUBMISSION_STATUS_KEY = 'contactSubmissionStatus';

const NotFound = () => {
  const theme = useTheme();
  const history = useHistory();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const submissionStatus = window.sessionStorage.getItem(
      CONTACT_SUBMISSION_STATUS_KEY,
    );
    const referrer = window.document.referrer || '';
    const currentOrigin = window.location.origin;
    const cameFromContact = referrer.startsWith(`${currentOrigin}/contact`);

    if (
      submissionStatus === 'submitted' ||
      (submissionStatus === 'pending' && cameFromContact) ||
      cameFromContact
    ) {
      window.sessionStorage.removeItem(CONTACT_SUBMISSION_STATUS_KEY);
      history.replace('/form-sent');
      return;
    }

    if (submissionStatus === 'error') {
      window.sessionStorage.removeItem(CONTACT_SUBMISSION_STATUS_KEY);
      history.replace('/contact/submission-error');
    }
  }, [history]);

  return (
    <Box
      minHeight={'calc(100vh - 64px - 183px)'}
      height={'100%'}
      display={'flex'}
      alignItems={'center'}
      bgcolor={theme.palette.alternate.main}
    >
      <Container>
        <Grid container spacing={6}>
          <Grid item container justifyContent={'center'} xs={12} md={6}>
            <Box
              height={'100%'}
              width={'100%'}
              maxWidth={{ xs: 500, md: '100%' }}
            >
              <NotFoundIllustration width={'100%'} height={'100%'} />
            </Box>
          </Grid>
          <Grid
            item
            container
            alignItems={'center'}
            justifyContent={'center'}
            xs={12}
            md={6}
          >
            <Box>
              <Typography
                variant="h1"
                component={'h1'}
                align={isMd ? 'left' : 'center'}
                sx={{ fontWeight: 700 }}
              >
                404
              </Typography>
              <Typography
                variant="h6"
                component="p"
                color="textSecondary"
                align={isMd ? 'left' : 'center'}
              >
                Oops! Looks like you followed a bad link.
                <br />
                If you think this is a problem with us, please{' '}
                <Link href={'/contact'} underline="none">
                  contact us
                </Link>
              </Typography>
              <Box
                marginTop={4}
                display={'flex'}
                flexWrap={'wrap'}
                gap={2}
                justifyContent={{ xs: 'center', md: 'flex-start' }}
              >
                <Button
                  component={Link}
                  variant="contained"
                  color="primary"
                  size="large"
                  href={'/'}
                >
                  Back home
                </Button>
                <Button
                  component={'a'}
                  variant="outlined"
                  color="primary"
                  size="large"
                  href={'/contact'}
                >
                  Contact us
                </Button>
                <Button
                  component={'a'}
                  variant="text"
                  color="primary"
                  size="large"
                  href={CONTACT_PHONE_LINK}
                >
                  Call {CONTACT_PHONE_DISPLAY}
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default NotFound;
